<template>
  <div class="tkc_img">
    <img class="tkc_img_item" :src="src || defaultSrc" />
  </div>
</template>

<script>
  export default {
    name: 'ImgComponent',
    props: {
      src: String,
      defaultSrc: {
        type: String,
        default:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=', // base64空白占位图
      },
    },
  };
</script>

<style lang="scss">
  .tkc_img {
    box-sizing: border-box;
    height: 100%;
    border: 1px solid #e7e7eb;
    text-align: center;
    font-size: 0;
    line-height: 0;
  }

  .tkc_img:after {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }

  .tkc_img_item {
    display: inline-block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
  }
</style>
